import { render, staticRenderFns } from "./MiddleLayout.vue?vue&type=template&id=10524bec&scoped=true"
import script from "./MiddleLayout.vue?vue&type=script&lang=js"
export * from "./MiddleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10524bec",
  null
  
)

export default component.exports